<template>
	<div id="register_page" class="register_box">
		<h4 class="color_5babf4 login_title">注册新账号</h4>
		<form action="#" method="">
			<div class="register_user login_mbtm6">
				<label class="label_focus" for="register_mob">手机号码</label>
				<input type="text" autocomplete="off" @keyup.enter="reg" class="form-control input_focus login_form" id="register_mob" v-model.trim="user.mobile" @blur="checkMobile();" maxlength="11" />
			</div>
			<div class="password login_mbtm6">
				<label class="label_focus" for="register_pwd">密码</label>
				<input type="password" autocomplete="off" @keyup.enter="reg" class="form-control input_focus login_form" id="register_pwd" v-model.trim="user.password" />
			</div>
			<div class="forget_yzm login_mbtm6">
				<label class="label_focus" for="register_yzm">验证码</label>
				<input type="text" autocomplete="off" @keyup.enter="reg" class="form-control inline-block input_focus login_form" id="register_yzm" v-model.trim="user.yzm" />
				<div class="yzm_box inline-block"><img id="verifyImg1" @click="fleshVerify()"></img>
				</div>
				<i class="glyphicon icon_reload" @click="fleshVerify()" id="cloudFreshenThree"></i>
			</div>
			<p class="tip_box kfzreg-hide">
				<small class="tip_yz regcontent">密码错误！</small>
			</p>
			<p class="login_btn_box">
				<a href="javascript:void(0);" class="btn btn_h btn_issue margin_r_7" @click="reg()" id="ypt_register">确定</a>
				<small class="color_9">已有账号，<router-link class="color_308de2" to="/login_page">立即登录</router-link></small>
				<!--<router-link to="/register_yz">确定</router-link>-->
			</p>
		</form>
	</div>
</template>

<script>

	export default {
		name: 'register_msg_yz',
		data() {
			return {
				user: {
					mobile: "",
					password: "",
					yzm: ""
				}
			}
		},
		mounted: function() {
			this.$nextTick(function() {
				localStorage.removeItem("token");
				localStorage.removeItem('loginUserType');
				this.$inputFocus(".input_focus");
				this.fleshVerify();
			})
		},
		methods: {
			fleshVerify() {
				var formData = Math.random();
				//重载验证码
				this.$http.post('/zklccloud/captcha.jpg', {
					formData
				}, {
					emulateJSON: true
				}).then(function(m) {
					var verify = document.getElementById('verifyImg1');
					verify.setAttribute('src', '/zklccloud/captcha.jpg?' + Math.random());
				})
			},
			checkMobile() {
				var mob = $.trim(this.user.mobile);
				var isMob = /^(?:13\d|14\d|15\d|18\d|17\d)\d{5}(\d{3}|\*{3})$/;
				if(!isMob.test(mob)) {
					$(".kfzreg-hide").removeClass("kfzreg-hide");
					$(".regcontent").text('请输入正确的手机号码');
					return;
				} else {
					$(".regcontent").text('');
					var formData = JSON.stringify(this.user);
					this.$http.post('/zklccloud/register/checkMob', formData, {
						emulateJSON: true
					}).then(function(m) {
						if(m.body.resultCode != 0) {
							$(".kfzreg-hide").removeClass("kfzreg-hide");
							$(".regcontent").text('您输入的手机号已经被注册过了,请重新输入');
							return;
						}
					})
				}

			},
			reg() {
				var pwd = $.trim(this.user.password);
				var mob = $.trim(this.user.mobile);
				var yzm = $.trim(this.user.yzm);
				var isMob = /^(?:13\d|14\d|15\d|18\d|17\d)\d{5}(\d{3}|\*{3})$/;
				if(mob == "") {
					$(".kfzreg-hide").removeClass("kfzreg-hide");
					$(".regcontent").text('手机号不能为空');
					this.fleshVerify();
					return;
				} else if(!isMob.test(mob)) {
					$(".kfzreg-hide").removeClass("kfzreg-hide");
					$(".regcontent").text('请输入正确的手机号码');
					return;
				}

				var ispwd=/^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,./]).{8,}$/;
				if(pwd == "") {
					$(".kfzreg-hide").removeClass("kfzreg-hide");
					$(".regcontent").text('密码不能为空');
					this.fleshVerify();
					return;
				} else if(!ispwd.test(pwd)) {
					$(".kfzreg-hide").removeClass("kfzreg-hide");
					$(".regcontent").text('密码由8位以上数字、字母和特殊符号组成,请重新输入');
					this.fleshVerify();
					return;
				}
				var yzm = $.trim(this.user.yzm);
				if(yzm == "") {
					$(".kfzreg-hide").removeClass("kfzreg-hide");
					$(".regcontent").text('验证码不能为空');
					this.fleshVerify();
					return;
				}
				/*var Num = "";
				for(var i = 0; i < 6; i++) {
					Num += Math.floor(Math.random() * 10);
				}
				this.user.memo = Num;*/
				var time1 = new Date();
				time1.setHours(0); //获取当前小时数(0-23)
				time1.setMinutes(0); //获取当前分钟数(0-59)
				time1.setSeconds(0); //获取当前秒数(0-59)
				time1.setMilliseconds(0); //获取当前毫秒数(0-999)
				var startTime = time1;
				var time2 = new Date();
				time2.setHours(23); //获取当前小时数(0-23)
				time2.setMinutes(59); //获取当前分钟数(0-59)
				time2.setSeconds(59); //获取当前秒数(0-59)
				time2.setMilliseconds(999); //获取当前毫秒数(0-999)
				var endTime = time2;
				this.user.startTime = startTime.valueOf();
				this.user.endTime = endTime.valueOf();
				var formData = JSON.stringify(this.user);
				this.$http.post('/zklccloud/register/sendMes', formData, {
					emulateJSON: true
				}).then(function(m) {
					if(m.body.content.switch == 1) {
						$(".kfzreg-hide").removeClass("kfzreg-hide");
						$(".regcontent").text('当天最多发送5次验证码,已超过限制！');
						this.fleshVerify();
						return;
					}
					if(m.body.content.repeat == 1) {
						$(".kfzreg-hide").removeClass("kfzreg-hide");
						$(".regcontent").text('您输入的手机号已经被注册过了,请重新输入');
						return;
					}
					if(m.body.resultCode == 0) {
						var mobile = m.body.content.mobile;
						var password = m.body.content.password;
						var memo = m.body.content.memo;
						this.$router.push({
							name: 'register_yz',
							params: {
								mobile: mobile,
								password: password,
								memo: memo
							}
						});
					} else if(m.body.resultCode == -2) {
						$(".kfzreg-hide").removeClass("kfzreg-hide");
						$(".regcontent").text('发送验证码失败,请联系管理员!');
						this.fleshVerify();
					} else {
						$(".kfzreg-hide").removeClass("kfzreg-hide");
						$(".regcontent").text('您输入的验证码有误,请重新输入');
						this.fleshVerify();
					}

				})
			}
		}
	}
</script>

<style scoped>
	.register_box {
		min-height: 500px;
	}
	.kfzreg-hide {
		visibility: hidden;
	}
</style>



// WEBPACK FOOTER //
// register_page.vue?50625e90